import { modal } from 'modal';
import { lazyImg } from 'lazy-img';

const loadFromNode = url => {
  const htmlNode = document.getElementById(url);

  if (!htmlNode) {
    console.error('no html node');
    return;
  }

  if (!modal.contentArea) {
    console.error('no content area in modal window');
    return;
  }
  modal.contentArea.innerHTML = htmlNode.innerHTML;
};

modal.addMethod('html-node-load', 'preload', loadFromNode);
modal.addMethod('html-node-load', 'onopen', lazyImg.getImages);



// WEBPACK FOOTER //
// ./src/js/modal-html-node-load.js